module.exports = __webpack_public_path__ + "img/logoNewWhite.791bb820.png";